import CONSTANTS from '../Constants'

export interface LangVariantTab {
  value: string
  label: string
  showSuccessCheck?: boolean
}

interface BuildLangVariantTabsParams {
  baseContentId: string | number
  baseVersionId: string
  metaCategory: string
  variantAssetLanguages: string[]
  variantsData: any[]
  markDoneStatus: any[]
  languagesMasters: any[]
}

const formatLang = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const buildLangVariantTabs = ({
  baseContentId,
  baseVersionId,
  metaCategory,
  variantAssetLanguages,
  variantsData,
  markDoneStatus,
  languagesMasters,
}: BuildLangVariantTabsParams): {
  tabs: LangVariantTab[]
  remainingLanguages: string[]
  languageOptions: any
} => {
  const variantLanguagesCopy = [...(variantAssetLanguages || [])]
  const remainingLanguages = []
  const markDoneObj =
    markDoneStatus?.find((item: any) => item.metaCategoryKey === metaCategory) || {}

  const baseCheckMarkStatus = markDoneStatus?.[0]?._id
    ? variantsData
        .find((item: any) => item.contentDetails?.contentId === baseContentId)
        ?.metaCategories.find((cat: any) => cat.metaCategoryKey === metaCategory)
        ?.markDoneStatus === 'PASS'
    : markDoneStatus[0]?.markDoneStatus === 'PASS'

  const tabsArray: LangVariantTab[] = [
    { value: baseVersionId, label: 'Base', showSuccessCheck: !!baseCheckMarkStatus },
  ]
  const tempVariantLang: any = []
  // Filter and sort variantsData based on variantLanguagesCopy
  const variantsDataCopy = [...variantsData]
    ?.filter(
      (variant: any) =>
        variantLanguagesCopy.includes(variant.defaultLang) &&
        variant.baseContentId === baseContentId,
    )
    ?.sort((a: any, b: any) => {
      const indexA = variantLanguagesCopy.indexOf(a.defaultLang)
      const indexB = variantLanguagesCopy.indexOf(b.defaultLang)
      return indexA - indexB
    })
  variantsDataCopy?.forEach((variant: any) => {
    const variantLang = variant.defaultLang
    const variantVersionId = variant.contentDetails._id
    if (!variantLang) return

    // Remove the used language from the list
    const index = variantLanguagesCopy.findIndex((lang) => lang === variantLang)
    if (index !== -1) remainingLanguages.push(variantLang)
    let showSuccessCheck
    if (markDoneObj?._id === variantVersionId) {
      showSuccessCheck = markDoneObj?.markDoneStatus === 'PASS'
    } else {
      showSuccessCheck = variant.metaCategories?.some(
        (item: any) => item.metaCategoryKey === metaCategory && item.markDoneStatus === 'PASS',
      )
    }
    if (variant.contentDetails.state !== CONSTANTS.ASSET_STATUS.CREATED) {
      showSuccessCheck = true
    }
    tempVariantLang.push(variantLang)
    const language = languagesMasters?.find((ele: any) => ele.key === variantLang)
    tabsArray.push({
      value: variantVersionId,
      label: formatLang(language?.value || variantLang),
      showSuccessCheck,
    })
  })
  const templanguage: any[] = []
  variantLanguagesCopy?.forEach((langKey: any) => {
    const language = languagesMasters?.find((ele: any) => ele.key === langKey)
    templanguage.push({
      _id: language?._id,
      key: language?.key,
      value: formatLang(language?.value || ''),
      isDisable: tempVariantLang?.includes(language?.key) ? true : false,
    })
  })
  return {
    tabs: tabsArray,
    remainingLanguages: variantLanguagesCopy,
    languageOptions: templanguage,
  }
}
